<template>
    <div :class="['visual-filters', {'is-open': isOpen}]">
        <button
            :class="['button-circle','visual-filters__open-button',
                {'button-circle_theme_white':  dataStep.step !== 'flat' },
                {'button-circle_theme_dark':  dataStep.step === 'flat' }
            ]"
            @click="isOpen = !isOpen"
        >
            <iconFilter className="visual-filters__svg-filter"/>
            <iconClose className="visual-filters__svg-close"/>
        </button>
        <form class="visual-filters__form" ref="form" @change="change">
            <ul class="visual-filters__list">
                <li class="visual-filters__list-item" v-for="item in filters.room" :key="item.id">
                    <ButtonCheckbox
                            :name="`room[${item.id}]`"
                            :checked="item.checked"
                            :disabled="item.disabled"
                            :value="item.title "
                            :modify="[
                                {'button-checkbox_theme_border': dataStep.step === 'flat'},
                                {'button-checkbox_theme_border': dataStep.step === 'section'}
                            ]"
                            @change="changeCookie(item)"
                    />
                </li>
            </ul>
        </form>
    </div>
</template>

<style lang="scss">
    @import "./Filters.scss";
</style>

<script>
import {mapActions, mapGetters} from 'vuex';
import ButtonCheckbox from 'components/button-checkbox/ButtonCheckbox.vue';
import Cookies from 'js-cookie';
import iconClose from '../Icons/icon-close.vue';
import iconFilter from '../Icons/icon-filter';

export default {
    data() {
        return {
            isOpen : false,
            cookies: Cookies.get('visual_filter')
        };
    },

    components: {
        ButtonCheckbox,
        iconClose,
        iconFilter
    },

    computed: {
        ...mapGetters({
            filters : 'GET_FILTERS',
            dataStep: 'GET_DATA_STEP'
        })
    },

    created() {
        this.getCookie();
    },

    methods: {
        ...mapActions(['changeFilter']),

        change() {
            this.changeFilter(this.$refs.form);
        },

        getCookie() {
            const cookies = Cookies.get('visual_filter');

            this.results = [];

            if (cookies) {
                this.results = cookies.replace(/\s/g, '').split(',');
            }
        },

        changeCookie(item) {
            item.checked = !item.checked;

            const id = String(item.id);

            if (item.checked) {
                this.setCookie(id);
            } else {
                this.removeCookie(id);
            }

            Cookies.set('visual_filter', this.results.toString());
        },

        setCookie(id) {
            this.results.push(id);
        },

        removeCookie(id) {
            this.results = this.results.filter((item) => {
                return item !== id;
            });
        }
    }
};
</script>
